export const badgeStatusMap = {
  nuevo: { text: 'Nuevo', variant: 'info' },
  resuelto: { text: 'Resuelto', variant: 'success' },
  pasa_a_proyecto: { text: 'Pasa a Proyecto', variant: 'success' },
  en_proceso: { text: 'En proceso', variant: 'warning' },
  pendiente_firma: { text: 'Pendiente firma', variant: 'warning' },
  pendiente_aprobacion_cliente: { text: 'Pend aprob cliente', variant: 'warning' },
  pendiente_informacion_asesor: { text: 'Pend inf Asesor', variant: 'warning' },
  informacion_incompleta: { text: 'Inf incompleta', variant: 'warning' },
  desestimado: { text: 'Desestimado', variant: 'dark' }
}

export const statusOptions = [
  { text: 'Nuevo', value: 'nuevo' },
  { text: 'Resuelto', value: 'resuelto' },
  { text: 'En proceso', value: 'en_proceso' },
  { text: 'Desestimado', value: 'desestimado' },
  { text: 'Pendiente firma', value: 'pendiente_firma' },
  { text: 'Pendiente aprobación cliente', value: 'pendiente_aprobacion_cliente' },
  { text: 'Pendiente información asesor', value: 'pendiente_informacion_asesor' },
  { text: 'Información incompleta', value: 'informacion_incompleta' },
  { text: 'Pasa a proyecto', value: 'pasa_a_proyecto' }
]

// Estados que cuentan como "Cerrados" (mantener sincronizado con el backend)
export const closedStatuses = ['resuelto', 'desestimado', 'pasa_a_proyecto']

export const allowedFileTypes = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.xlsx',
  '.csv',
  '.dwg',
  '.docx',
  '.pptx',
  '.dwf'
]

const thBase = 'align-middle text-muted font-lato'

export const ticketColumns = [
  { key: 'id', label: 'ID', sortable: true, locked: true, default: true,
    tdClass: 'align-middle clickable text-center fs-14', thClass: `${thBase} text-center`, thStyle: { width: '70px' } },
  { key: 'user_id', label: 'Solicitante', sortable: true, default: true,
    tdClass: 'align-middle clickable', thClass: thBase, thStyle: { width: '270px' } },
  { key: 'request_type', label: 'Tipo de solicitud', default: false,
    tdClass: 'align-middle clickable cell-text', thClass: thBase, thStyle: { minWidth: '190px' } },
  { key: 'title', label: 'Título', locked: true, default: true,
    tdClass: 'align-middle clickable cell-text', thClass: thBase, thStyle: { minWidth: '250px' } },
  { key: 'description', label: 'Descripción', default: false,
    tdClass: 'align-middle clickable cell-text', thClass: thBase, thStyle: { minWidth: '250px' } },
  { key: 'agent_id', label: 'Asignado', default: true,
    tdClass: 'align-middle clickable', thClass: thBase, thStyle: { width: '180px' } },
  { key: 'status', label: 'Estado', sortable: true, default: true,
    tdClass: 'text-center align-middle clickable', thClass: `${thBase} text-center`, thStyle: { width: '130px' } },
  { key: 'created_at', label: 'Creado', sortable: true, default: true,
    tdClass: 'text-center align-middle clickable', thClass: `${thBase} text-center`, thStyle: { width: '120px' } },
  { key: 'updated_at', label: 'Última actualización', locked: false, sortable: true, default: true,
    tdClass: 'align-middle text-center clickable', thClass: thBase, thStyle: { width: '180px' } }
]

export const ticketColumnKeys = ticketColumns.map(c => c.key)
export const defaultTicketColumnKeys = ticketColumns.filter(c => c.default).map(c => c.key)
export const lockedTicketColumnKeys = ticketColumns.filter(c => c.locked).map(c => c.key)